import React, { useEffect, useState, useRef, useMemo } from "react";
import "../common/common.scss";
import { Link, useLocation } from "react-router-dom";
import urls from "../../utils/url";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookie from "js-cookie";
import Cookies from "js-cookie";
import moment from "moment";
import { isJson } from "../../utils/converter";

import { AlertAudio } from "../../pages/central_monitor/central_monitor_graph/AlertAudio";
import { GRAPH_PLACE_IDS } from "../../utils/graphPlaceIds";
import { performLogout } from "../../utils/logout";

const SideLayout = () => {
  const cookie = Cookie.get("access_token");
  const [activeIndex, setActiveIndex] = useState();
  const [loading, setLoading] = useState(false);
  const clickTimeoutRef = useRef(null);

  const [isCollapsed, setIsCollapsed] = useState(() => {
    const stored = sessionStorage.getItem("sidebarCollapsed");
    return stored ? JSON.parse(stored) : false;
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  const navigate = useNavigate();
  const [accountType, setAccountType] = useState();
  const isUltraAdmin =
    JSON.parse(Cookie.get("data") || "{}").is_ultra_admin === true;
  const [isBasicAnalytics, setIsBasicAnalytics] = useState(() => {
    return sessionStorage.getItem("basicAnalyticsEnabled") === "true";
  });

  const [images, setImages] = useState({
    Logo: "",
    Icon: "",
  });

  const location = useLocation();

  useEffect(() => {
    const cookieData = Cookie.get("data");
    if (cookieData) {
      const parsedData = JSON.parse(cookieData);
      const account_type = parsedData.account_type;
      const logo = parsedData.logo;
      const icon = parsedData.icon;

      setImages({ Logo: logo, Icon: icon });
      setAccountType(account_type);
    }
  }, [accountType]);

  const handleClick = (index) => {
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
    }

    clickTimeoutRef.current = setTimeout(() => {
      setActiveIndex(index);

      const pathList = [
        "/dashboard/analytics",
        "/dashboard/super-admin-analytics",
        "/dashboard/report",
        "/dashboard/profile",
        "", // logout
        "/dashboard/basic-analytics",
      ];

      const targetPath = pathList[index];
      if (targetPath && targetPath !== location.pathname) {
        navigate(targetPath);
      }
    }, 50);
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (clickTimeoutRef.current) {
        clearTimeout(clickTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const pathList = [
      "/dashboard/analytics",
      "/dashboard/super-admin-analytics",
      "/dashboard/report",
      "/dashboard/profile",
      "",
      "/dashboard/basic-analytics",
    ];
    const currentIndex = pathList.findIndex((obj) => obj === location.pathname);
    setActiveIndex(currentIndex);
  }, [location, navigate]);

  const [analyticsType, setAnalyticsType] = useState("none"); // 'old', 'superadmin', 'basic', 'none'

  useEffect(() => {
    if (!accountType) return;

    const hospitalDetail = JSON.parse(Cookie.get("hospital_detail") || "{}");
    const placeId = Number(hospitalDetail?.hospitalID);
    const hasValidPlaceId = GRAPH_PLACE_IDS.includes(placeId);
    const isBasicOrPremium = ["Basic", "Premium"].includes(accountType);

    // Basic analytics: Basic/Premium AND in graph place IDs
    const isUltraAdmin =
      JSON.parse(Cookie.get("data") || "{}").is_ultra_admin === true;
    const basicAnalytics =
      (isBasicOrPremium && hasValidPlaceId) || isUltraAdmin;

    if (basicAnalytics) {
      setAnalyticsType("basic");
    } else if (!["Basic", "Daksh SI", "Navam"].includes(accountType)) {
      setAnalyticsType("old");
    } else {
      setAnalyticsType("none");
    }
  }, [accountType]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth <= 1024) {
        setIsMobile(true);
        setIsCollapsed(true);
      } else {
        setIsMobile(false);
        setIsCollapsed(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!analyticsType || analyticsType === "none") return;

    const currentPath = location.pathname;
    const isDashboardRoot =
      currentPath === "/dashboard" || currentPath === "/dashboard/";
    const isOldAnalyticsRoute = currentPath === "/dashboard/analytics";
    const isBasicAnalyticsRoute = currentPath === "/dashboard/basic-analytics";

    if (analyticsType === "basic" && (isDashboardRoot || isOldAnalyticsRoute)) {
      navigate("/dashboard/basic-analytics");
    } else if (
      analyticsType === "old" &&
      (isDashboardRoot || isBasicAnalyticsRoute)
    ) {
      navigate("/dashboard/analytics");
    }
  }, [analyticsType, location.pathname, navigate]);

  const handleLogout = async () => {
    setLoading(true);
    await performLogout(navigate);
    setLoading(false);
  };

  const toggleCollapse = () => {
    if (isMobile) {
      setIsCollapsed(!isCollapsed);
    } else {
      const newState = !isCollapsed;
      setIsCollapsed(newState);
      sessionStorage.setItem("sidebarCollapsed", JSON.stringify(newState));
      const event = new CustomEvent("sidebarStateChange", {
        detail: { isCollapsed: newState },
      });
      window.dispatchEvent(event);
    }
  };

  return (
    <div className={`side-layout ${isCollapsed ? "collapsed" : "open"}`}>
      <div
        className="side-header"
        onClick={toggleCollapse}
        style={{ cursor: "pointer" }}
      >
        <img src="/menu.svg" alt="menu" className="menu-icon" />
        {!isCollapsed && <p className="menu-text">Menu</p>}
      </div>

      <img
        src="/hr.svg"
        alt="Horizontal Line"
        style={{ marginTop: `2rem` }}
        className="sidelayout-hr"
      />

      <div className="sidelayout">
        <div className="upper-sidelayout">
          {/* Show Old Analytics (for non-Basic/Premium accounts or Premium without SuperAdmin conditions) */}
          {analyticsType === "old" && (
            <div style={{ display: "flex" }}>
              <div
                className={activeIndex == 0 ? "active" : "in-active"}
                onClick={() => handleClick(0)}
              >
                <Link
                  to={`/dashboard/analytics`}
                  className={"side-name"}
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="side-text">
                    <img
                      src={
                        activeIndex == 0
                          ? "/active-analytics.svg"
                          : "/analytics.svg"
                      }
                      alt="circle"
                      className="circle-img active-image"
                    />
                    {!isCollapsed && <p className="text">Analytics</p>}
                  </div>
                </Link>
              </div>
              {activeIndex === 0 && !isCollapsed && (
                <img src="/active.png" alt="active" className="active-sign" />
              )}
            </div>
          )}

          {/* Show Basic Analytics (for Basic accounts) */}
          {analyticsType === "basic" && (
            <div style={{ display: "flex" }}>
              <div
                className={activeIndex === 5 ? "active" : "in-active"}
                onClick={() => handleClick(5)}
              >
                <Link
                  to={`/dashboard/basic-analytics`}
                  className={"side-name"}
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="side-text">
                    <img
                      src={
                        activeIndex === 5
                          ? "/active-analytics.svg"
                          : "/analytics.svg"
                      }
                      alt="analytics"
                      className="circle-img active-image"
                    />
                    {!isCollapsed && <p className="text">Analytics</p>}
                  </div>
                </Link>
              </div>
              {activeIndex === 5 && !isCollapsed && (
                <img src="/active.png" alt="active" className="active-sign" />
              )}
            </div>
          )}

          <div style={{ display: "flex" }}>
            <div
              className={activeIndex == 2 ? "active" : "in-active"}
              onClick={() => handleClick(2)}
            >
              <Link
                to={`/dashboard/report`}
                className="side-name"
                onClick={(e) => e.preventDefault()}
              >
                <div className="side-text">
                  <img
                    src={
                      activeIndex == 2 ? "/active-reports.svg" : "/reports.svg"
                    }
                    alt="circle"
                    className="circle-img active-image"
                  />
                  {!isCollapsed && <p className="text">Patient Reports</p>}
                </div>
              </Link>
            </div>
            {activeIndex == 2 && !isCollapsed && (
              <img src="/active.png" alt="active" className="active-sign" />
            )}
          </div>

          {accountType &&
            !["Daksh SI"].includes(accountType) &&
            !isUltraAdmin && (
              <div style={{ display: "flex" }}>
                <div className={"in-active"}>
                  <Link
                    to={`/dashboard/central-monitor`}
                    className="side-name"
                    onClick={() => AlertAudio.unlock()}
                  >
                    <div className="side-text">
                      <img
                        src={"/central-monitor.svg"}
                        alt="circle"
                        className="circle-img"
                      />
                      {!isCollapsed && <p className="text">Central Monitor</p>}
                    </div>
                  </Link>
                </div>
              </div>
            )}

          <img
            src="/hr.svg"
            alt="Horizontal Line"
            style={{ marginBottom: `2rem` }}
            className="sidelayout-hr"
          />
        </div>

        <div className="lower-sidelayout">
          <div>
            <div style={{ display: "flex" }}>
              <div
                className={activeIndex == 3 ? "active" : "in-active"}
                onClick={() => handleClick(3)}
              >
                <Link
                  to={`/dashboard/profile`}
                  className="side-name"
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="side-text">
                    <img
                      src={
                        images?.Icon
                          ? images.Icon
                          : activeIndex == 3
                            ? "/active-settings.svg"
                            : "/settings.svg"
                      }
                      alt="Hospital Icon"
                      className="circle-img active-image"
                    />
                    {!isCollapsed && <p className="text">Profile</p>}
                  </div>
                </Link>
              </div>
              {activeIndex == 3 && !isCollapsed && (
                <img src="/active.png" alt="active" className="active-sign" />
              )}
            </div>

            <div>
              <div
                className={activeIndex == 4 ? "active" : "in-active"}
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout();
                }}
              >
                <Link
                  to="#"
                  className="side-name"
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="side-text">
                    <img
                      src={
                        activeIndex == 4 ? "/active-logout.svg" : "/logout.svg"
                      }
                      alt="circle"
                      className="circle-img"
                    />
                    {!isCollapsed && <p className="text">Logout</p>}
                  </div>
                </Link>
              </div>
              {activeIndex == 4 && !isCollapsed && (
                <img src="/active.png" alt="active" className="active-sign" />
              )}
            </div>
          </div>

          <img src="/hr.svg" alt="Horizontal Line" className="sidelayout-hr" />
        </div>

        <div className="sidelayout-footer">
          <img
            src="/janitri-registered-logo.svg"
            alt="Janitri Logo"
            className={`sidelayout-janitri-logo ${isCollapsed ? "sidebar-collapsed" : ""}`}
          />
        </div>
      </div>
    </div>
  );
};

export default SideLayout;
